import { render, staticRenderFns } from "./Average.vue?vue&type=template&id=729259c1&"
import script from "./Average.vue?vue&type=script&lang=js&"
export * from "./Average.vue?vue&type=script&lang=js&"
import style0 from "./Average.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports